<div
  class="product-monitore-container"
  [ngClass]="{ recommended: shopWindowItem.preferred }"
>
  <div class="header"
    [ngClass]="{
      recommended: shopWindowItem.preferred,
      notRecommended: !shopWindowItem.preferred
    }"
  >
    <span
      class="recommendedText"
      *ngIf="shopWindowItem.preferred; else notRecommended"
      >Recomendado
      </span>
    <ng-template #notRecommended>
      <span class="notRecommendedText"></span>
    </ng-template>
  </div>
  <div class="card">
    <div class="planName">
      <p class="name">{{ shopWindowItem.cardTitle }}</p>
      <p class="detail">Assinatura {{ shopWindowItem.product.periodicity }}</p>
    </div>
    <div class="planDescription">
      <strong>{{ shopWindowItem.featureList[0].name }}</strong>
    </div>
    <div class="planPrice">
      <span class="totalValue" *ngIf="isAppliedDiscounts()">
        De <span class="censored">R$ {{ getValue("baseValue") }}</span> por:
      </span>
      <span> Em até {{ getValue("maxInstallment") }}x de </span>
      <span class="currencyPerMonth">
        <strong>R$ {{ getValue("monthlyValue") }}</strong> / mês
      </span>
      <span>
        no cartão de crédito
      </span>
      <span class="price">
        ou <strong>{{ getValue("totalValue") }}</strong> à vista
      </span>
    </div>
    <div class="button">
      <button (click)="onClick()">
        <span class="buttonText">{{ shopWindowItem.buttonName }}</span>
      </button>
    </div>
  </div>
</div>
